export default __webpack_public_path__ + "static/media/send.ea324d88.svg";